import { useTranslation } from 'react-i18next';

import type { AuditLogEntry } from '../../../api/types';
import { EmptyState } from '../../../shared/ui/EmptyState';
import { Table } from '../../../shared/ui/Table';
import styles from './AuditLogTable.module.css';

interface AuditLogTableProps {
  entries: AuditLogEntry[];
}

// PARA-106, AC-9: таблица audit log, отсортирована backend'ом occurred_at DESC.
export function AuditLogTable({ entries }: AuditLogTableProps): JSX.Element {
  const { t } = useTranslation();

  if (entries.length === 0) {
    return <EmptyState>{t('logs.empty')}</EmptyState>;
  }

  return (
    <Table>
      <thead>
        <tr>
          <th>{t('logs.columns.occurredAt')}</th>
          <th>{t('logs.columns.adminId')}</th>
          <th>{t('logs.columns.actionType')}</th>
          <th>{t('logs.columns.target')}</th>
          <th>{t('logs.columns.changes')}</th>
        </tr>
      </thead>
      <tbody>
        {entries.map((entry) => (
          <tr key={entry.id}>
            <td className={styles.mono}>{entry.occurred_at}</td>
            <td className={styles.mono}>{entry.admin_id}</td>
            <td>{entry.action_type}</td>
            <td className={styles.mono}>{entry.target}</td>
            <td>
              <code className={styles.changes}>{JSON.stringify(entry.changes)}</code>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
}
